module.exports = __webpack_public_path__ + "img/5-4.e9e8912c.svg";